import EquipamentoFormPage from "./EquipamentoFormPage"

export default function EquipamentoEdit() {
  return <EquipamentoFormPage />
}
